export default __webpack_public_path__ + "static/media/avatar-placeholder.05262aba.png";